'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.end_user_index', {
        url: 'user_index',
        template: '<end-user-index></end-user-index>'
    });
};



// WEBPACK FOOTER //
// ./public/dev/app/end_user/index/end_user_index.routes.js